import { firstLetter, getRecurrenceString } from 'common'
import React from 'react'
import useTranslation from '../hooks/UseTranslation'

const ListingIcons = ({ listing }) => {
  const { t } = useTranslation()
  const [audiences, setAudiences] = React.useState()

  React.useEffect(() => {
    let levelAudiences = []
    const otherAudiences = []
    let levelAud = 0b000
    listing.audiences?.forEach((aud) => {
      if (aud.level) {
        levelAudiences.push(aud)
        // eslint-disable-next-line no-bitwise
        levelAud |= aud.level
      } else {
        otherAudiences.push(aud)
      }
    })
    if (levelAud === 0b111) {
      // all audiences
      levelAudiences = [
        {
          name: t('all_levels'),
          level: 0b111
        }
      ]
    }
    setAudiences([...levelAudiences, ...otherAudiences])
  }, [listing])

  return (
    (listing.audiences || listing.is_private) && (
      <ul className='list-inline mb-4'>
        {audiences?.map((audience) => (
          <li key={audience.name} className='list-inline-item mr-3'>
            <div className='d-flex align-items-center'>
              <i className='fa fa-chevron-right text-secondary mr-2' />
              <span>{audience.name}</span>
            </div>
          </li>
        ))}
        {listing.is_private && (
          <li key='listingPrivate' className='list-inline-item mr-3'>
            <div className='d-flex align-items-center'>
              <i className='far  fa-eye-slash mr-1' />{' '}
              <span>{firstLetter(t('private'))}</span>
            </div>
          </li>
        )}
        {listing.frequency && (
          <li key='listingFrequency' className='list-inline-item mr-3'>
            <div className='d-flex align-items-center'>
              <i className='fa fa-sync-alt mr-1' />{' '}
              <span>
                {firstLetter(getRecurrenceString(listing.frequency, t))}
              </span>
            </div>
          </li>
        )}
      </ul>
    )
  )
}

export default ListingIcons
